import { EonColor, DatePickerSchemeConfiguration } from "../../../constants/colors";
import { DefaultLocalization } from "../../../common/localizable-component";
import { InputSchemeName } from "../../../components";

export class Day {
  date: number;
  day: number;
  month: number;
  year: number;
  constructor(date: number, day: number, month: number, year: number) {
    this.date = date;
    this.day = day;
    this.month = month;
    this.year = year;
  }

  get timestamp(): number {
    return new Date(this.year, this.month, this.date).getTime();
  }
}

export interface DatePickerLocalization extends DefaultLocalization {
  dateFormat: string;
  locale: string;
  dateRangeErrorMessage: string;
  weekendErrorMessage: string;
  disableDatesErrorMessage: string;
  nextMonth: string;
  prevMonth: string;
  chooseDate: string;
  openCalendar: string;
  closeCalendar: string;
  dateFnsLocale;
}

export interface DatePickerSchemeDefinition {
  fontColor: EonColor;
  popupBackgroundColor: EonColor;
  popupBorderColor: EonColor;
  separatorColor: EonColor;
  dayBorderHoverColor: EonColor;
  dayBorderSelectedColor: EonColor;
  dayBackgroundColor: EonColor;
  dayBackgroundTodayColor: EonColor;
  dayFontDisabledColor: EonColor;
  dayFontOtherMonthColor: EonColor;
  monthYearButtonBorderColor: EonColor;
  scrollbarBackgroundColor: EonColor;
  scrollbarThumbColor: EonColor;
  monthYearToggleBorderColor: EonColor;
  monthYearToggleBorderHoverColor: EonColor;
  monthYearToggleBorderActiveColor: EonColor;
  monthYearToggleBackgroundActiveColor: EonColor;
  internalInputScheme: InputSchemeName;
}

export type DatePickerSchemeName = keyof DatePickerSchemeConfiguration<DatePickerSchemeDefinition>;

export type SelectedDatePart = "" | "d" | "m" | "y";
